import ErrorBoundary from './components/ErrorBoundary';
import { ThemeProvider } from 'styled-components';
import { darkTheme, lightTheme } from './components/stateProvider/Themes';
import { useGlobalState } from './components/stateProvider/StateProvider';
import LogIn from './components/pages/LogIn';
import Modal from './components/Modal';
import { GlobalStyle } from './components/stateProvider/GlobalStyles';
import { useEffect, useLayoutEffect, useState } from 'react';
import { lastKeyPress, getLocal, setLocal, getDeviceFingerprint } from './components/utility/functions';
import ToS from './components/pages/ToS';
import UsersContext from './components/stateProvider/UsersContext';
import DashRouter from './components/navigation/DashRouter';
import { Route, Routes } from 'react-router-dom';
import HelpToolTip from './components/HelpToolTip';
import ModalFactory from './components/Modal';
import { NewUpdateLanding } from './components/pages/Updates';
import KioskSignup from './components/processors/KioskSignup';
import { isProd } from './constants/config';
require('typeface-montserrat')

function App() {
    const {
        state: {
            active_user,
            dark_theme,
            seasonal
        },
        updateUnauthorized,
        toggleSeasonal,
    } = useGlobalState();

    useLayoutEffect(() => {

        // const info = getDeviceFingerprint();
        // const temp = [info.cpuCores, info.screenResolution, info.platform, info.userAgent].join('|');
        // const encode = btoa(temp);
        // const decode = atob(encode);

        if (!isProd) {
            console.log('ENV:', process.env.REACT_APP_ENV);
            // setTimeout(() => console.clear(), 500)
        }

        updateUnauthorized();

        const keyDownHandler = e => lastKeyPress.key = e.key;
        document.addEventListener('keydown', keyDownHandler);
        return () => document.removeEventListener('keydown', keyDownHandler);
    }, []);

    useEffect(() => {
        if (active_user.isLoggedIn && !active_user.tosAccepted) {
            ModalFactory.show({
                id: 'ToS',
                title: 'Hosted Solutions Terms of Service',
                body: <ToS />,
                hideClose: true
            })
        }

        if (active_user.isLoggedIn && active_user.tosAccepted && seasonal === undefined) {
            ModalFactory.confirmation({
                title: 'Enable Seasonal Effects?',
                body: 'Would you like to enable the seasonal effects? This can be turned on/off on your account settings at any time.',
                closeAfter: true
            })
                .then(res => {
                    toggleSeasonal(res)
                })
        }
    }, [active_user.isLoggedIn, active_user.tosAccepted]);

    useEffect(() => {
        if (active_user.isLoggedIn && active_user.tosAccepted && active_user.userId) {
            const landingKey = `${active_user.userId}_landing`;
            if (!getLocal(landingKey)) {
                setLocal(landingKey, true);
                ModalFactory.show({
                    title: `Hi ${active_user.firstName}!`,
                    body: <NewUpdateLanding />,
                })
            }
        }
    }, [active_user]);

    return (
        <ErrorBoundary>
            <ThemeProvider theme={dark_theme ? darkTheme : lightTheme}>
                <GlobalStyle />
                <UsersContext>
                    <HelpToolTip>
                        <Modal />
                        <Routes>
                            <Route index path={'/AccountSetUp/:token'} element={<KioskSignup />} />
                            <Route path='*' element={(
                                <>
                                    <LogIn />
                                    {(active_user.isLoggedIn && active_user.tosAccepted) ? <DashRouter /> : null}
                                </>
                            )} />
                        </Routes>
                    </HelpToolTip>
                </UsersContext>
            </ThemeProvider>
        </ErrorBoundary>
    );
}

export default App;
